import launchDarkly from '@bambeehr/vue-launch-darkly';
import useMiddlewareContext from './hooks/useMiddlewareContext';
import { AppRoutes } from '@/constants/Routes';
import FeatureFlags from '@/constants/FeatureFlags';
import { getLandingPagePath } from '@/utils/landingPage';
import Store from '@/constants/Store';

export default async () => {
  const { route, redirect, store } = useMiddlewareContext();

  if (route.path.includes('/operating-posture')) {
    console.log(
      '[H3_FLYWHEEL_MIDDLEWARE] Redirecting /operating-posture to /operating-feed',
      {
        originalPath: route.path,
        redirectTo: AppRoutes.OPERATING_FEED,
      }
    );
    redirect(AppRoutes.OPERATING_FEED);
  }

  // Operating feed is now accessible to employees, managers, and admins
  // Role-based content filtering is handled by the nuc app via useUserRole

  if (route.path.includes(AppRoutes.TASK_CENTER)) {
    redirect(getLandingPagePath(store.state.current_user?.role));
  }

  // Redirect dashboard to operating feed when h3-flywheel is enabled
  // Check if we're on the dashboard route (handles /dashboard, /dashboard/, /dashboard/index, etc.)
  const isDashboardRoute =
    route.path === AppRoutes.DASHBOARD ||
    route.path === `${AppRoutes.DASHBOARD}/` ||
    route.path.startsWith(`${AppRoutes.DASHBOARD}/index`);

  if (isDashboardRoute) {
    const isCompanyAdmin = store.getters[Store.auth.Getters.IS_COMPANY_ADMIN];

    // Only redirect company admins - non-admins stay on dashboard
    if (!isCompanyAdmin) {
      return;
    }

    const landingPath = getLandingPagePath(store.state.current_user?.role);
    if (landingPath !== AppRoutes.DASHBOARD) {
      console.log(
        `[H3_FLYWHEEL_MIDDLEWARE] Redirecting /dashboard to ${landingPath}`,
        {
          originalPath: route.path,
          redirectTo: landingPath,
        }
      );
      redirect(landingPath);
    }
  }
};
